export default "__VITE_ASSET__bd01b6bf__"